<template>
    <AuthenticatedLayout>
        <div class="mb-4">
            <PairsHorisontalMenu
                :currentPairSymbol="pair.symbol"
                :pairsData="pairsData"
                :menuPairs="menuPairs"
                :url="'dashboard_old'"
            />
        </div>
        <Toast position="top-center" />

        <div class="mb-4 flex">
            <div class="mr-4">
                <Card>
                    <template #content>
                        <CandlesWithDeals
                            :candles="candles"
                            :deals="[...closedDeals, ...openDeals]"
                            :zeroPrice="zeroPrice"
                            :pair="pair.symbol"
                            :timezone="0"
                            :width="1000"
                        />
                    </template>
                </Card>
            </div>

            <div class="flex flex-column w-full">

                <Card>
                    <template #content>
                        <div class="flex flex-row">
                            <div>
                                <div v-if="marketState.longTrend === 'red'" class="text-red-600">Trend: <b>{{marketState.longTrend}}</b></div>
                                <div v-if="marketState.longTrend === 'early_red'" class="text-red-600">Trend: {{marketState.longTrend}}</div>
                                <div v-if="marketState.longTrend === 'green'" class="text-green-600">Trend: <b>{{marketState.longTrend}}</b></div>
                                <div v-if="marketState.longTrend === 'early_green'" class="text-green-600">Trend: {{marketState.longTrend}}</div>
                            </div>
                            <div class="ml-3">
                                <div v-if="marketState.emaTrendUpAt">Up: {{short_timezoned(marketState.emaTrendUpAt)}}</div>
                                <div v-if="marketState.emaTrendDownAt">Down: {{short_timezoned(marketState.emaTrendDownAt)}}</div>
                            </div>
                            <div class="ml-3">peak_drop: {{round(marketIndicatorsData.peak_drop, 4)}}</div>
                            <div class="ml-3">peak_rise: {{round(marketIndicatorsData.peak_rise, 4)}}</div>
                            <div class="ml-3">peak_highest_age: {{marketIndicatorsData.peak_highest_age}}m</div>

                        </div>
                    </template>
                </Card>

                <div class="mt-2 flex flex-row">

                    <div class="flex-auto">
                        <Card>
                            <template #content>
                                <div class="mb-2 flex flex-row align-items-center">
                                    <div class="text-xl font-bold">Hll Bot</div>
                                    <div class="ml-4">
                                        <div v-if="hllBot.is_active === 1" class="flex flex-row align-items-center">
                                            <div class="mr-2 text-green-500">Бот активен</div><div><Button class="p-button-text p-button-sm" @click="stopBot(userBot.id)">Остановить</Button></div>
                                        </div>
                                        <div v-else class="flex flex-row align-items-center">
                                            <div class="mr-2 text-600">Бот остановлен</div><div><Button class="p-button-text p-button-sm" @click="startBot(userBot.id)">Запустить</Button></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2">
                                    riseValue: {{hllBot.riseValue}}
                                </div>

                                <TabView :activeIndex.sync="activeTrendTab" >
                                    <TabPanel v-for="userBot in userBotsEdited" :key="userBot.id">
                                        <template #header>
                                            <span>{{userBot.name}}</span>
                                        </template>

                                        <div class="json-editable">
                                            <textarea v-model="userBot.json_settings" style="height: 317px" class="w-full bg-orange-50 text-sm border-0 active:border-0"></textarea>
                                        </div>
                                        <div class="mt-2 flex flex-row justify-content-between">
<!--                                            <SpinnerWrapper :loading="isBotSaving"><Button @click="saveBotSettings(userBot.id)">Сохранить</Button></SpinnerWrapper>-->
<!--                                            <Button @click="resetBotSettings(userBot.id)" class="p-button-danger p-button-outlined">Сбросить в дефолт</Button>-->
                                        </div>
                                    </TabPanel>
                                </TabView>

                            </template>
                        </Card>
                    </div>
                </div>
            </div>
        </div>




        <div class="flex">
            <div class="flex-1">
                <Card>
                    <template #title>
                        Открытые cделки {{pair.symbol}}
                    </template>
                    <template #content>
                        <DataTable :value="openDeals" dataKey="token">
                            <Column header="Токен" field="token" ></Column>
                            <Column header="Покупка" >
                                <template #body="slotProps">
                                    {{short_timezoned(slotProps.data.started_at)}}
                                </template>
                            </Column>
                            <Column header="Причина" field="start_reason" ></Column>
                            <Column header="Курс" field="rate_started" ></Column>
                            <Column header="Текущий курс" >
                                <template #body="slotProps">
                                    {{currentPrice}}
                                </template>
                            </Column>
                            <Column header="Текущий %">
                                <template #body="slotProps">
                                    {{round(calculatePercentProfit(slotProps.data, currentPrice), 4)}}
                                </template>
                            </Column>
                            <Column header="Потенциальный профит" >
                                <template #body="slotProps">
                                    <div>{{round(calculatePercentProfit(slotProps.data, currentPrice) * slotProps.data.value_amount_started - slotProps.data.value_amount_started, 4)}}</div>
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <div class="flex justify-content-center align-content-center w-3rem h-2rem">
                                        <div v-if="isSellDeal === slotProps.data.id">
                                            <ProgressSpinner style="width:20px;height:20px" class="mt-1" strokeWidth="4" animationDuration=".9s"/>
                                        </div>
                                        <div v-else>
                                            <Button @click="sellDeal(slotProps.data.id)" class="p-button-text p-button-danger p-button-sm">Продать</Button>
                                        </div>
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                    </template>
                </Card>

                <Card class="mt-4">
                    <template #title>
                        Закрытые cделки {{pair.symbol}}
                    </template>
                    <template #content>
                        <div v-if="closedDeals.length > 0">
                            <DataTable :value="closedDeals" selectionMode="single" dataKey="token">
                                <Column header="Токен" field="token" ></Column>
                                <Column header="Покупка" >
                                    <template #body="slotProps">
                                        {{short_timezoned(slotProps.data.started_at)}}
                                    </template>
                                </Column>
                                <Column header="Причина" field="start_reason" ></Column>
                                <Column header="Курс" field="rate_started" ></Column>
                                <Column header="Продано" >
                                    <template #body="slotProps">
                                        <span v-if="slotProps.data.completed_at">{{short_timezoned(slotProps.data.completed_at)}}</span>
                                    </template>
                                </Column>
                                <Column header="Длительность" field="open_minutes" ></Column>
                                <Column header="Причина" field="complete_reason" ></Column>
                                <Column header="%" field="percent_profit" >
                                    <template #body="slotProps">
                                        <div v-if="slotProps.data.percent_profit">
                                            <div v-if="slotProps.data.percent_profit < 1" v-html="round_red(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                                            <div v-else v-html="round_green(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                                        </div>
                                    </template>
                                </Column>
                                <Column header="Профит" field="value_profit" >
                                    <template #body="slotProps">
                                        <div v-if="slotProps.data.value_profit">
                                            <div v-html="round_colored(slotProps.data.value_profit, 2)"></div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div v-else>
                            <p>Отсутствуют.</p>
                        </div>
                    </template>
                </Card>

            </div>
            <div class="flex-1 ml-4">
                <Card>
                    <template #title>
                        Логи {{pair.symbol}}
                    </template>
                    <template #content>
                        <div v-if="logs.length > 0">
                            <LogsTable :logs="logs"></LogsTable>
                        </div>
                        <div v-else>
                            <p>Логи отсутствуют.</p>
                        </div>
                    </template>
                </Card>
            </div>
        </div>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { Link } from '@inertiajs/vue2'
import helperMethods from '@/helpers'
import PairsHorisontalMenu from "@/Menu/PairsHorisontalMenu";
import CandlesWithDeals from "@/Charts/Candles.vue";
import Toast from 'primevue/toast';
import ProgressSpinner from 'primevue/progressspinner';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import SpinnerWrapper from "@/Components/SpinnerWrapper";
import InputNumber from 'primevue/inputnumber';
import LogsTable from "@/Tables/LogsTable.vue";

// import Contenteditable from 'vue-contenteditable';

export default {
    props: {
        openDeals: Array,
        closedDeals: Array,
        candles: Array,
        logs: Array,
        availableUsd: String,
        pairsData: Array,
        pair: Object,
        userBots: Array,
        currentPrice: String,
        zeroPrice: String,
        menuPairs: String,
        marketState: Object,
        marketIndicators: Array,
        marketIndicatorsData: Object,

        candlesChartData: Array,
        dealsChartData: Array,

        flash: Object
    },
    components:{
        LogsTable,
        CandlesWithDeals,
        PairsHorisontalMenu,
        // Contenteditable,
        AuthenticatedLayout, DataTable, InputText, Button, Column, Card, Link, Toast, ProgressSpinner, TabView, TabPanel, SpinnerWrapper,
        InputNumber
    },
    data(){
        return {
            userBotsEdited: [],
            hllBotForm: {},
            isSellDeal: 0,
            activeTrendTab: 0,
            activeIndicatorTab: 0,
            isBotSaving: false
        }
    },
    mounted() {
        this.userBotsEdited = this.userBots;
        this.hllBotForm.zoneSettings = this.hllBot.zoneSettings;
    },
    watch:{
        userBots(newUserBots, oldUserBots){
            this.userBotsEdited = this.userBots;
            this.hllBotForm = this.hllBot.settings;
        },
        flash(newFlash, oldFlash){
            if(newFlash.success !== null){
                this.$toast.add({severity:'success', summary: 'Success', detail: newFlash.success, life: 3000});
            }
            if(newFlash.error !== null){
                this.$toast.add({severity:'error', summary: 'Error', detail: newFlash.error, life: 5000});
            }
        }
    },
    computed: {
        hllBot(){
            return this.userBots.find(bot => bot.reason === 'hll');
        },
        hllBotEdited(){
            return this.userBotsEdited.find(bot => bot.reason === 'hll');
        },
        trends(){
            return ['early_red', 'red', 'early_green', 'green'];
        },
    },
    methods:{
        ...helperMethods,
        saveBotSettings(id){
            this.isBotSaving = true;
            this.$inertia.post('/dashboard/store_bot_settings', {
                id: id,
                settings: this.userBotsEdited.find(bot => bot.id === id).json_settings
            },{
                onSuccess: (page) => {  this.isBotSaving = false;  }
            })
        },
        startBot(id){
            this.$inertia.post('/dashboard/start_bot', {
                id: id
            });
        },
        stopBot(id){
            this.$inertia.post('/dashboard/stop_bot', {
                id: id
            });
        },
        sellDeal(dealId){
            this.isSellDeal = dealId;
            this.$inertia.post('/dashboard/sell_deal', {
                deal_id: dealId
            });
        },
        resetBotSettings(id){
            this.$inertia.post('/dashboard/reset_bot_settings', {
                id: id
            });
        }
    }
}
</script>

